import { MessageAnalysesModel } from 'src/components/messages/analysesModel';

class PatientAnalysesModel extends MessageAnalysesModel {
  id = 'PatientAnalysesModel';

  _events = {
    profile: 'handleProfile',
    openPatient: 'onOpenPatient',
    'foxsocket:message:analyse': 'onMessage'
  };
  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  listParams(loadMore) {
    const req = super.listParams(loadMore);

    if (!req) return null;

    return {
      ...req,
      patientId: req.partnerId
    };
  }
  onOpenPatient = (patient = null) => {
    if (!patient?.id) return;

    this.onOpenContact({
      contact: {
        ...patient,
        partnerId: patient.id
      }
    });
  };
}
const analysesModel = new PatientAnalysesModel();

export default analysesModel;
